<template> 
  <div class="p-2 bg-white border rounded"> 
      <div class="alert alert-warning pt-4 mb-0"> 
          <p> 
              <strong class="gap-10px d-flex"> 
                  {{ 'Task Cancelled'| trans }}</strong 
              > 
          </p> 
      </div> 
  </div> 
</template> 
<script>
export default{
  name:"Cancelled"
}
</script> 
<style lang="scss" scoped></style> 